import fetchJsonp from 'fetch-jsonp';
import qs from 'qs';
import Risk from './risk';
export default class Verify {
  /**
   * 校验器通用的请求API
   * @param {string} code 校验器Code
   * @param {boolean} openRisk 是否开启风控校验
   */
  static async request(code, openRisk = false) {
    const params = {
      activityCode: code,
    };
    if (openRisk) {
      const token = await Risk.getToken();
      params.act_umidToken = token.umidToken;
      params.act_ua = token.collina;
    }
    return fetchJsonp(`//page.aliyun.com/validate/verify.json?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 'VALIDATE_SUCCESS' || res.code == 'success') {
          // 校验器通过
          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errorCode: res.code,
            msg: res.msg,
          };
        }
      });
  }
  /**
   * 校验器通用的请求API
   * @param {string} code 校验器Code
   * @param {boolean} openRisk 是否开启风控校验
   */
  static async query(code, openRisk = false) {
    const params = {
      activityCode: code,
    };
    if (openRisk) {
      const token = await Risk.getToken();
      params.act_umidToken = token.umidToken;
      params.act_ua = token.collina;
    }
    return fetchJsonp(`//page.aliyun.com/validate/verify.json?${qs.stringify(params)}`)
      .then(res => res.json())
      .then(res => {
        if (res.code == 'VALIDATE_SUCCESS' || res.code == 'success') {
          // 校验器通过
          return true;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/verify.js